import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class ChangeChipService {

  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }

  /**
   * Description: Método que llama el servicio web de validar ICC
   * Autor: Diego Diaz
   * @param valueICC ICCID del chip
   * @return Mensaje de confirmación de la validación
   */
  validateICC(valueICC, isPreActivatedChip = false) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_VALIDATE_ICC+constants.PARAMETER_ENDPOINT_VALIDATE_ICC+isPreActivatedChip, { "valueICC": valueICC });
  }

  /**
   * Description: Método que llama el servicio web de enviar solicitud de cambio de chip
   * Autor: Diego Diaz
   * @param jsonData parámetros de entrada del servicio
   * @return Mensaje de confirmación del envio de solicitud
   */
  sendChangeChipRequest(jsonData) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_CHANGE_CHIP_REQUEST, jsonData);
  }
}
